function addRequires(obj) {
  if (obj.hasOwnProperty('unitsMin') || obj.hasOwnProperty('unitsMax') || obj.hasOwnProperty('unitsCount'))
    obj.requires = {};

  if (obj.hasOwnProperty('unitsMin')) {
    obj.requires['$gte'] = { unitsCount: obj.unitsMin };

    if (obj.unitsMin > 1) {
      obj.requiresHint = 'Es müssen mindestens ' + obj.unitsMin + ' Zähne gewählt werden';
    }
  }
  if (obj.hasOwnProperty('unitsMax')) {
    obj.requires['$lte'] = { unitsCount: obj.unitsMax };

    if (obj.hasOwnProperty('unitsMin')) {
      obj.requiresHint = 'Es müssen zwischen '  + obj.unitsMin + ' und ' + obj.unitsMax + ' Zähne gewählt werden';
    } else {
      obj.requiresHint = 'Es dürfen maximal ' + obj.unitsMax + ' Zähne gewählt werden';
    }
  }
  if (obj.hasOwnProperty('unitsCount')) {
    obj.requires.unitsCount = obj.unitsCount;

    if (obj.unitsCount == 1) {
      obj.requiresHint = 'Nur für Einzelzähne verfügbar';
    }
  }
}

// pickerColor + pickerText
/*
"properties":
{
		"itemref":
		{
				"defaultValue": "S.FR.04533",
				"type": "hidden",
				"value": "S.FR.04533"
		}
},

"some_item": {
"label": "some test"
"color": "#fff",
"properties": { "selectionColor": {}, "selectionText: {}}
}
*/

module.exports = function(layer) {
	let fullTree = require('../ProductTree.json');
	let tree = JSON.parse(JSON.stringify(fullTree));

	Object.keys(tree.children).forEach((key) => {
		var removeNode = true,
				lastUnitsMin = false,
				lastUnitsMax = false,
				lastUnitsCount = false;

		if (tree.children[key].hasOwnProperty('selectionColor')) {
			if (!tree.children[key].hasOwnProperty('properties')) {
				tree.children[key].properties = {};
			}
			tree.children[key].properties.selectionColor = {
				defaultValue: tree.children[key].selectionColor,
				"type": "hidden"
			}
		}
		if (tree.children[key].hasOwnProperty('selectionText')) {
			if (!tree.children[key].hasOwnProperty('properties')) {
				tree.children[key].properties = {};
			}
			tree.children[key].properties.selectionText = {
				defaultValue: tree.children[key].selectionText,
				"type": "hidden"
			}
		}

		if (tree.children[key].hasOwnProperty('children')) {
			Object.keys(tree.children[key].children).forEach((skey) => {
				if (tree.children[key].children[skey].hasOwnProperty('layer') && tree.children[key].children[skey].layer === layer) {
					removeNode = false;

					addRequires(tree.children[key].children[skey]);

					if (tree.children[key].children[skey].hasOwnProperty('unitsMin')) {
						if (lastUnitsMin === false) {
							lastUnitsMin = tree.children[key].children[skey].unitsMin;
						} else if (lastUnitsMin != tree.children[key].children[skey].unitsMin) {
							lastUnitsMin = null;
						}
					}
					if (tree.children[key].children[skey].hasOwnProperty('unitsMax')) {
						if (lastUnitsMax === false) {
							lastUnitsMax = tree.children[key].children[skey].unitsMax;
						} else if (lastUnitsMax != tree.children[key].children[skey].unitsMax) {
							lastUnitsMax = null;
						}
					}
					if (tree.children[key].children[skey].hasOwnProperty('unitsCount')) {
						if (lastUnitsCount === false) {
							lastUnitsCount = tree.children[key].children[skey].unitsCount;
						} else if (lastUnitsCount != tree.children[key].children[skey].unitsCount) {
							lastUnitsCount = null;
						}
					}
				} else {
					delete tree.children[key].children[skey];
				}
			});
		}

		if (removeNode) {
			console.log('Remove node', key, layer);
			delete tree.children[key];
		} else {
			console.log('Add node', key, layer);
			if (lastUnitsMin)
				tree.children[key].unitsMin = lastUnitsMin;
			if (lastUnitsMax)
				tree.children[key].unitsMax = lastUnitsMax;
			if (lastUnitsCount)
				tree.children[key].unitsCount = lastUnitsCount;
		}
	});

	return tree;
};